'use strict';

var ToNumber = require('./ToNumber');

// http://262.ecma-international.org/5.1/#sec-9.5

module.exports = function ToInt32(x) {
	return ToNumber(x) >> 0;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/ToInt32.js
// module id = 1330
// module chunks = 0